<template>
<div class="PostsList">
  <PostsListItem 
    class="PostsList__item"
    v-for="(post, index) in posts"
    :key="post.id + '_' + index"
    :post="post" />
</div>
</template>
<script>
  import PostsListItem from './PostsListItem';

  export default {
    name: 'PostsList',
    components: {
      PostsListItem
    },
    props: {
      posts: {
        type: Array,
        required: true
      }
    }
  }
</script>
<style>
  .PostsList__item {
    margin: 60px 10px;
  }
</style>
